export default __webpack_public_path__ + "static/media/708.a842deb5.gif";